var map = {
	"./Awards": 41,
	"./Awards.js": 41,
	"./digital_thought_of_the_year.jpeg": 113,
	"./elacma_award.jpeg": 114,
	"./global_digital_health_company_of_the_year.jpeg": 115,
	"./leverging_technology_for_earl_disease.jpeg": 116
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;